var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconosparainterfazdepostulaciones10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.2 101.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #8390aa;\r\n        opacity: .78;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #737d8c;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.87,7.58H20.33c-5.61,0-10.17,4.56-10.17,10.18v65.59c0,5.61,4.56,10.17,10.17,10.17h10.65l2.5-.23v-14.03c0-3.72,2.51-6.97,5.83-7.55,2.16-.38,4.24.18,5.88,1.55,1.62,1.36,2.54,3.35,2.54,5.46v12.3l.23,2.49h12.91c5.61,0,10.17-4.56,10.17-10.17V17.76c0-5.61-4.56-10.18-10.17-10.18ZM66.52,83.35c0,3.11-2.53,5.64-5.64,5.64h-8.61v-10.26c0-3.45-1.52-6.7-4.16-8.92-2.64-2.22-6.12-3.15-9.57-2.55-5.46.95-9.58,6.11-9.58,12.01v9.72h-8.61c-3.11,0-5.64-2.53-5.64-5.64V17.76c0-3.12,2.53-5.65,5.64-5.65h40.54c3.11,0,5.64,2.53,5.64,5.65v65.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.77,
    y: 23.99,
    width: 12.95,
    height: 12.95,
    rx: 2.59,
    ry: 2.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.49,
    y: 23.99,
    width: 12.95,
    height: 12.95,
    rx: 2.59,
    ry: 2.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.77,
    y: 45.15,
    width: 12.95,
    height: 12.95,
    rx: 2.59,
    ry: 2.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.49,
    y: 45.15,
    width: 12.95,
    height: 12.95,
    rx: 2.59,
    ry: 2.59
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.87,7.58H20.33c-5.61,0-10.17,4.56-10.17,10.18v65.59c0,5.61,4.56,10.17,10.17,10.17h10.65l2.5-.23v-14.03c0-3.72,2.51-6.97,5.83-7.55,2.16-.38,4.24.18,5.88,1.55,1.62,1.36,2.54,3.35,2.54,5.46v12.3l.23,2.49h12.91c5.61,0,10.17-4.56,10.17-10.17V17.76c0-5.61-4.56-10.18-10.17-10.18ZM66.52,83.35c0,3.11-2.53,5.64-5.64,5.64h-8.61v-10.26c0-3.45-1.52-6.7-4.16-8.92-2.64-2.22-6.12-3.15-9.57-2.55-5.46.95-9.58,6.11-9.58,12.01v9.72h-8.61c-3.11,0-5.64-2.53-5.64-5.64V17.76c0-3.12,2.53-5.65,5.64-5.65h40.54c3.11,0,5.64,2.53,5.64,5.65v65.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.77,
    y: 23.99,
    width: 12.95,
    height: 12.95,
    rx: 2.59,
    ry: 2.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.49,
    y: 23.99,
    width: 12.95,
    height: 12.95,
    rx: 2.59,
    ry: 2.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.77,
    y: 45.15,
    width: 12.95,
    height: 12.95,
    rx: 2.59,
    ry: 2.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.49,
    y: 45.15,
    width: 12.95,
    height: 12.95,
    rx: 2.59,
    ry: 2.59
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconosparainterfazdepostulaciones10);
export default __webpack_public_path__ + "static/media/Iconos para interfaz de postulaciones-10.a0cb913842f3ac5ee57f22e0c8263b24.svg";
export { ForwardRef as ReactComponent };